import { ClientItemId } from 'owa-client-ids';
import { isConnectedAccount } from 'owa-accounts-store';

export function getGroupOrAccountFromItemId(
    itemId: ClientItemId
): {
    group: string | undefined;
    account: string | undefined;
} {
    if (isConnectedAccount(itemId.mailboxInfo.userIdentity)) {
        return { group: undefined, account: itemId.mailboxInfo.userIdentity };
    } else if (itemId.mailboxInfo.type == 'GroupMailbox') {
        return { group: itemId.mailboxInfo.mailboxSmtpAddress, account: undefined };
    }

    return { group: undefined, account: undefined };
}

export function splitEmailAddress(
    address: string
): {
    alias: string;
    domain: string;
} {
    const [alias, domain] = address.split('@');
    return { alias: alias, domain: domain };
}

export function buildEmailAddress(alias: string, domain: string): string {
    return `${alias}@${domain}`;
}
